import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { motion, useInView } from "framer-motion";

export function SmoothScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
}

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

const line = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

export function MaskedLines({ lines, className = "" }) {
  return (
    <span className={className}>
      {lines.map((l, i) => (
        <span key={i} className="reveal-mask">
          <motion.span custom={i} variants={line} initial="hidden" animate="show" className="block">
            {l}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Counter({ children }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  return <span ref={ref} className={inView ? "opacity-100" : "opacity-0"}>{children}</span>;
}
